<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
const strokeClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <rect width="24" height="24" :class="colorClass" />
    <rect width="288" height="4231" transform="translate(-216 -3107)" fill="white" />
    <g clip-path="url(#clip0_404_270)">
      <g clip-path="url(#clip1_404_270)">
        <path
          d="M6.37988 18.3799H10.3799V5.37988H6.37988V18.3799ZM7.37988 6.37988H9.37988V17.3799H7.37988V6.37988ZM13.3799 5.37988V18.3799H17.3799V5.37988H13.3799ZM16.3799 17.3799H14.3799V6.37988H16.3799V17.3799Z"
          :class="colorClass"
        />
        <path
          d="M11.88 22.26C17.6127 22.26 22.26 17.6127 22.26 11.88C22.26 6.14728 17.6127 1.5 11.88 1.5C6.14728 1.5 1.5 6.14728 1.5 11.88C1.5 17.6127 6.14728 22.26 11.88 22.26Z"
          :class="strokeClass"
          stroke-miterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_404_270">
        <rect width="192" height="4047" fill="white" transform="translate(-168 -2971)" />
      </clipPath>
      <clipPath id="clip1_404_270">
        <rect width="21.75" height="21.75" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
